import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import queryString from "query-string";

import { checkNestedObject } from "utils/checkNestedObject";
import { checkAMLob } from "utils/checkAMLob";
import { setAnalyticsAttribute, sendCustomEvent } from "utils/taggingUtils";

class GlobalHelper extends Component {
  componentDidMount() {
    if (window.NodeList && !NodeList.prototype.forEach) {
      NodeList.prototype.forEach = Array.prototype.forEach;
    }

    // const userInfoCookie = getCookie("userinfo");
    // const loggedInCookie = getCookie("islogin");
    // const hasRedirected = sessionStorage.getItem("hasRedirected");

    // if (
    //   (checkAMLob() === "vzt" || window.reactGlobals.oneVZ === "Y") &&
    //   (!userInfoCookie || !loggedInCookie)
    // ) {
    //   if (!hasRedirected) {
    //     sessionStorage.setItem("hasRedirected", "true");
    //     window.location.href = window.reactGlobals.myverizonRouterUrl;
    //   }
    // }

    setTimeout(() => {
      setAnalyticsAttribute("#root, #notification_banner, #logged_out_landing_banner");
    }, 1);

    const waitForGlobal = (callback, n) => {
      const navListElements = document.querySelectorAll(
        ".gnav20 .gnav20-account-box .gnav20-dropdown-menu > ul"
      );

      if (navListElements && navListElements.length && this.props.gnavDropdown.label) {
        callback();
      } else {
        if (n <= 50) {
          setTimeout(function() {
            n++;
            waitForGlobal(callback, n);
          }, 100);
        }
      }
    };

    try {
      if (this.isLoggedIn()) {
        if (checkNestedObject(window, "vzdl", "scEvents")) {
          if (!window.profileError) {
            window.vzdl.scEvents = "event10";
          } else {
            window.vzdl.scEvents = "event11";
          }
        }
      }

      this.updateVzdl();

      waitForGlobal(() => {
        function updateNavLinks(linkArray) {
          const linkHTML =
            '<li class="gnav20-dropdown-list"><a class="gnav20-dropdown-list-item" href="insertHREF" aria-label="insertAriaLabel">insertLabel</a></li>';

          const navListElements = document.querySelectorAll(
            ".gnav20 .gnav20-account-box .gnav20-dropdown-menu > ul"
          );

          if (navListElements && navListElements.length) {
            for (let i = 0; i < navListElements.length; i++) {
              const l = navListElements[i].children.length;
              for (let ii = l - 1; ii >= 0; ii--) {
                if (!navListElements[i].children[ii].classList.contains("gnav20-goback")) {
                  navListElements[i].removeChild(navListElements[i].children[ii]);
                }
              }
              for (let ii = 0; ii < linkArray.length; ii++) {
                navListElements[i].innerHTML += linkHTML
                  .replace("insertHREF", linkArray[ii].href)
                  .replace("insertLabel", linkArray[ii].label)
                  .replace("insertAriaLabel", linkArray[ii].label);
              }
            }
          }

          const signInBackMenu = document.querySelectorAll(
            ".gnav20-mobile #gnav20-mobile-menu .gnav20-account-box .gnav20-dropdown-menu .gnav20-goback"
          );

          if (signInBackMenu && signInBackMenu.length) {
            for (let ii = 0; ii < signInBackMenu.length; ii++) {
              if (window.signinContentHide) {
                signInBackMenu[ii].removeEventListener("click", window.signinContentHide);
                signInBackMenu[ii].addEventListener("click", window.signinContentHide);
              }
            }
          }
        }

        const desktopDropdownLabel = document.getElementById("gnav20-sign-id");
        const mobileDropdownLabel = document.getElementById("gnav20-sign-id-mobile");

        const { label, list } = this.props.gnavDropdown;

        if (
          checkAMLob() === "vzw" ||
          checkAMLob() === "vzt" ||
          checkAMLob() === "ott" ||
          checkAMLob() === "autoapp" ||            //developer Arvind
          checkAMLob() === "ip" ||                 //developer Arvind
          checkAMLob() === "agent" ||
          checkAMLob() === "nico" ||
          checkAMLob() === "vils"
        ) {
          const insertHtmlSpans = label => `
            <span>
              <span>
                ${label}
              </span>
            </span>
          `;

          if (desktopDropdownLabel) {
            desktopDropdownLabel.innerHTML = insertHtmlSpans(label);
          }
          if (mobileDropdownLabel) {
            mobileDropdownLabel.textContent = label;
          }
          updateNavLinks(list);

          // if (checkAMLob() === "agent") {
          //   updateNavLinks(this.props.gnavDropdown);
          // } else {
          //   const aemDropdownExists =
          //     checkNestedObject(window.landingPageJsonData, "sections", [2], "gnavDropdown") ||
          //     this.props.gnavDropdown;

          //   const links = [
          // { label: "Sign out / switch account", href: `${domain}/privacy/secure/logout` },
          // { label: "My dashboard", href: `${domain}/privacy/secure/authorized-agent` },
          // { label: "Request history", href: `${domain}/privacy/secure/authorized-agent` },
          // { label: "FAQ", href: `${domain}/support/ccpa-faqs/#authorized-agent` }
          //   ];
          // }
        }

        // const unAuthorized = window.location.pathname.match(
        //   /(disconnected|be-unauthorized|account-not-supported|wireline-sub-account)/
        // );

        // if (unAuthorized) {
        //   updateNavLinks([]);
        // }
      }, 0);
    } catch (error) {}
  }

  componentDidUpdate(prevProps) {
    const { showModal, landingPageLoading, loading } = this.props;

    if (showModal !== prevProps.showModal) {
      if (showModal === true) {
        setTimeout(() => {
          setAnalyticsAttribute(".Modal");
        }, 1);
      }
    }

    if (loading !== prevProps.loading) {
      if (loading === false) {
        setTimeout(() => {
          setAnalyticsAttribute("#root, #notification_banner");
        }, 1);
      }
    }

    if (landingPageLoading !== prevProps.landingPageLoading) {
      if (landingPageLoading === false) {
        setTimeout(() => {
          setAnalyticsAttribute("#root, #notification_banner");
        }, 1);
      }
    }

    if (this.props.location.pathname !== prevProps.location.pathname) {
      setAnalyticsAttribute("#root, #notification_banner");
      if (checkNestedObject(window, "vzdl", "scEvents")) {
        if (window.vzdl.scEvents) {
          window.vzdl.scEvents = "";
        }
      }
      this.updateVzdl();
    }
  }

  isLoggedIn() {
    return window.location.pathname.indexOf("/secure/") !== -1;
  }

  updateVzdl() {
    const { vzdl, location } = window;
    if (checkNestedObject(window, "vzdl", "page", "name")) {
      const pathName = location.pathname;
      const lastSlash = pathName.lastIndexOf("/");
      if (lastSlash !== -1) {
        vzdl.page.name = pathName.substring(lastSlash + 1);
      }
    }
    if (checkNestedObject(window, "vzdl", "user", "authStatus")) {
      vzdl.user.authStatus = !this.isLoggedIn() ? "anonymous" : "loggedin";
    }
    if (checkNestedObject(window, "vzdl", "target", "campaign")) {
      const qp = queryString.parse(location.search);

      if (qp.intcmp) {
        vzdl.target.campaign = qp.intcmp;
      }
    }

    sendCustomEvent("pageViewUpdate");
  }

  render() {
    return <Fragment />;
  }
}

const mapStateToProps = ({
  modalState: { showModal },
  downloadAndDelete: { loading: landingPageLoading },
  loadingAndErrorState: { loading },
  pageContent: { gnavDropdown }
}) => ({ showModal, landingPageLoading, loading, gnavDropdown });

export default compose(
  connect(mapStateToProps),
  withRouter
)(GlobalHelper);
